<template>
  <div class="carousel-container" @click="closeCarousel()" ref="carouselContainer">
    <!-- <button @click="closeCarousel()" class="carousel-close-control">🞮</button> -->
    <section class="carousel-content-container" ref="contentContainer">
      <div v-for="(card, i) in cards" :key="i"
        @click.stop="toggleCard()"
        :class="[ 'carousel-card-container', { 'carousel-card-container--active': Xcursor == i } ]"
      >
        <folded-card
          v-if="type == 'card'"
          :is-open="i == Xcursor && isOpen"
          :orientation="card.orientation"
          :class="[ 'carousel-card', { 'carousel-card--active': i == Xcursor } ]"
        >
          <img slot="cover-front"   class="cover-image"   :src="`assets/cards/${card.name}/cover.png`" />
          <img slot="backing-front" class="content-image" :src="`assets/cards/${card.name}/contents.png`" />
        </folded-card>

        <photo-card
          v-if="type == 'photo'"
          :is-flipped="i == Xcursor && isOpen"
          :orientation="card.orientation"
          :class="[ 'carousel-card', { 'carousel-card--active': i == Xcursor } ]"
        >
          <img slot="card-front" class="cover-image" :src="`assets/cards/photos/${card.name}.jpg`" />
          <img slot="card-back" class="content-image" :src="`assets/cards/photo-backs/${card.name}-back.jpg`" />
          <!-- <div slot="backing-front" class="content-image" :style="{ backgroundImage: `url('assets/cards/${card.name}/contents.png')` }"></div> -->
        </photo-card>

      </div>
    </section>
    <nav @click.stop="closeCard()" class="carousel-nav-container">
      <button @click.stop="previous()" class="carousel-nav-control carousel-prev-control"
        :disabled="!hasPrevious"></button>
      <span   class="carousel-nav-index">Card {{ Xcursor + 1 }} of {{ cards.length }}</span>
      <button @click.stop="next()" class="carousel-nav-control carousel-next-control"
        :disabled="!hasNext"></button>
    </nav>
  </div>
</template>

<script>

export default {
  props: [ 'cards', 'type', 'cursor' ],
  data() {
    return {
      Xcursor: 0,
      isOpen: false
    };
  },
  computed: {
    hasNext()     { return this.Xcursor + 1 < this.cards.length; },
    hasPrevious() { return this.Xcursor > 0; }
  },
  methods: {
    closeCarousel() { this.$emit("close"); },

    goTo(target) {
      target = +target;
      if (target != target || 0 > target || target >= this.cards.length) return;

      this.Xcursor = target;
      this.isOpen = false;

    },
    previous() { this.goTo(this.Xcursor - 1); },
    next()     { this.goTo(this.Xcursor + 1); },

    toggleCard() { this.isOpen = !this.isOpen; },
    closeCard()  {
      this.isOpen = false;
      
      const c = this.cards[this.Xcursor];
      window.gtag('event', 'close_card', {
        event_label: `${this.type}__${c.name}`
      });
    },
    openCard()   {
      this.isOpen = true;
      
      const c = this.cards[this.Xcursor];
      window.gtag('event', 'open_card', {
        event_label: `${this.type}__${c.name}`
      });
    }
  },
  created() {
    this.Xcursor = this.cursor;
  },
  mounted() {
    const carousel = this.$refs.carouselContainer;
    const content  = this.$refs.contentContainer;
    carousel.addEventListener("mousemove", (event) => {
      const rx = -5 + 10*(event.clientX / window.innerWidth);
      const ry =  5 - 10*(event.clientY / window.innerHeight);
      content.style.transform = `rotateY(${rx}deg) rotateX(${ry}deg)`;
    });

    let i = 0;
    let anchorOrientation;
    window.addEventListener("deviceorientation", event => {
      let { alpha, beta, gamma } = event;

      // i++;
      // if ((i % 10) == 0) console.log( alpha, beta, gamma);

      if (alpha > 180) alpha -= 360;
      alpha /= 180;
      gamma /= 90;
      beta  /= 180;


      if (!anchorOrientation)
        anchorOrientation = { alpha, beta, gamma };


      alpha -= anchorOrientation.alpha; 
      beta  -= anchorOrientation.beta; 
      gamma -= anchorOrientation.gamma; 


      const rz =  24*alpha;
      const ry = -24*gamma;
      const rx =  24*beta;
      content.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) rotateZ(${rz}deg)`;
    });
  },
  watch: {
    cursor(target) { this.goTo(target); }
  }
  
}
</script>

<style lang="scss">
.carousel-container {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  padding: 5vw;
  perspective: 1000px;

  transform-style: flat;
  * { transform-style: preserve-3d; }

  &:before {
    content: "";
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    transform-origin: center;
    transform: translateZ(-50vw) scale(3, 3); // approximation of z depth of rotated cards
  }
}

.carousel-nav-container {
  color: palegoldenrod;
  
  margin-top: 40px;
  text-align: center;
  font: bold 24px/1 'Raleway', sans-serif;
}

.carousel-nav-index {
  margin: 0 20px;
}

.carousel-nav-control {
  color: inherit;
  font: inherit;
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 2px solid currentcolor;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  transition: all .5s;

  &:before {
    font-weight: 400;
    font-size: 50px;
    line-height: 25px;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 15px -2.5px currentcolor;
    transform: scale(1.05);
  }

  &:active { outline: none; }
  &.carousel-prev-control:active {
    box-shadow: 10px 0 15px 2.5px currentcolor;
    transform: translateX(-4px) scale(1.15);
  }
  &.carousel-next-control:active {
    box-shadow: -10px 0 15px 2.5px currentcolor;
    transform: translateX(4px) scale(1.15);
  }

  &:disabled {
    opacity: 0.4;
    background-color: rgba(0, 0, 0, 0.15);
    cursor: not-allowed;
    transform: scale(0.9);
    box-shadow: none;
  }
}
.carousel-prev-control:before { content: "‹"; }
.carousel-next-control:before { content: "›"; }



$target-active-card-width: 90vw;
    $max-active-card-width: calc(90vh - 150px);
$target-active-card-height: $target-active-card-width * 5/7;
    $max-active-card-height:    calc((90vh - 150px) * 5/7);

.carousel-content-container {
  position: relative;
  width: $target-active-card-width;
  max-width: $max-active-card-width;
  margin: 0 auto;

  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
  }
}

.carousel-card {

  &.card--vertical {
    width:      $target-active-card-height;
    max-width:     $max-active-card-height;
    height:     $target-active-card-width;
    max-height:    $max-active-card-width;
    margin: auto;
  }

  &.card--horizontal {
    width:      $target-active-card-width;
    max-width:     $max-active-card-width;
    height:     $target-active-card-height;
    max-height:    $max-active-card-height;
  }
}

.carousel-card-container {
  position: absolute;
  top: 0;
  display: flex;
  width: 100%;
  height: 100%;

  align-items: center;

  transform:  translate(-120%, -50%) rotate3d(10, 10, 10, -40deg)  scale(0);
  transition: transform .7s;
  

  &.carousel-card-container--active {
    transform: none;
  }

  .carousel-card-container--active ~ & {
    transform: translate(120%, -50%) rotate3d(10, 10, 10, 40deg) scale(0);
  }
}
</style>


// WEBPACK FOOTER //
// carousel.vue?1bc604aa